<template>
  <div class="h-full w-full d-flex flex-column align-center justify-center">
    <v-card
      :width="width"
      class="py-11 px-9 rounded-base"
      elevation="0"
      color="bg"
      style="border: 3px solid"
      :style="{
        border: $vuetify.breakpoint.mobile ? 'none' : '3px solid',
        borderColor: secondaryColor + '!important',
      }"
    >
      <slot />
    </v-card>
    <v-card
      color="transparent"
      :width="width"
      class="mt-1"
      elevation="0"
      v-if="!$vuetify.breakpoint.mobile"
    >
      <v-select
        v-model="$i18next.language"
        @input="(e) => (lang = e)"
        append-icon="$arrow-down"
        :items="langs"
        solo
        class="void"
        background-color="bg"
        style="width: 220px; border: none !important"
        hide-details="true"
      >
      </v-select>
    </v-card>
  </div>
</template>
<script>
import { useThemeStore } from "@/stores/theme";
import { mapWritableState } from "pinia";
export default {
  data: () => ({
    langs: [
      { value: "br", text: "Português" },
      { value: "en", text: "Inglês" },
    ],
    width: 430,
  }),
  computed: {
    ...mapWritableState(useThemeStore, ["lang"]),
    secondaryColor() {
      return this.$vuetify.theme.themes[
        this.$vuetify.theme.dark ? "dark" : "light"
      ].secondary;
    },
  },
};
</script>
<style scoped>
.m-auto {
  margin-left: auto;
  margin-right: auto;
}
::v-deep .theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #252831;
}
::v-deep
  .void.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none;
}
</style>
